import React, { useCallback, useEffect, useState } from 'react';
import { useDropzone } from 'react-dropzone';

const DropImageZone = ({ onFileSelect }) => {
  const [previewUrl, setPreviewUrl] = useState(null);
  const [fileName, setFileName] = useState(null);

  const onDrop = useCallback(
    (acceptedFiles) => {
      if (acceptedFiles.length > 0) {
        const file = acceptedFiles[0];
        setPreviewUrl(URL.createObjectURL(file));
        onFileSelect(file);
        setFileName(file.name);
      }
    },
    [onFileSelect],
  );

  useEffect(() => {
    return () => {
      if (previewUrl) {
        URL.revokeObjectURL(previewUrl);
      }
    };
  }, [previewUrl]);

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: 'image/png, image/jpeg',
    maxFiles: 1,
  });

  return (
    <>
      <div className="text-center">
        <div
          {...getRootProps()}
          className="border border-dashed rounded p-4 cursor-pointer"
          style={{
            borderColor: '#ccc',
            backgroundColor: isDragActive ? '#f0f0f0' : 'transparent',
            transition: 'background-color 0.3s',
          }}
        >
          <input {...getInputProps()} />
          <i
            className="fas fa-cloud-upload-alt upload-icon"
            style={{ fontSize: 30, color: '#999' }}
          ></i>
          <p className="mt-2 mb-0">
            <strong>Drag & drop</strong> or <strong>click</strong> to select an image
          </p>
          <p style={{ fontSize: '12px', color: '#999' }}>Only JPG, JPEG, PNG files supported</p>
          {fileName && (
            <p className="mt-2 mb-0 text-dark" style={{ fontSize: '14px' }}>
              <strong>Selected File:</strong> {fileName}
            </p>
          )}
        </div>
      </div>

      {previewUrl && (
        <div className="mt-3 text-center">
          <img
            src={previewUrl}
            alt="Preview"
            style={{
              maxWidth: '40%',
              maxHeight: '200px', 
              display: 'inline-block',
              borderRadius: 4,
              border: '1px solid #ccc',
              boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
            }}
          />
        </div>
      )}
    </>
  );
};

export default DropImageZone;
